import { observer, useLocalObservable } from 'mobx-react-lite';
import { Box } from '@mui/material';
import './scss/create-reseller.style.scss';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import { CustomerLoading } from '../../component/loading/loading';
import DialogComponent from '../../component/dialog/dialog.component';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ResellerState } from './reseller-management.state';
import ResellerAccount from './reseller-account.page';
import { ResellerAccountState } from './reseller-account-state';

/**
 * 新建经销商弹窗内容
 */
const CreateResellerDialog = observer(({ useResellerData }: { useResellerData: ResellerState }) => {

    useTranslation()
    // 解构数据
    const { isLoading, isOpenDialog } = useResellerData;

    // 经销商账号新增数据管理
    const useResellerAccountData = useLocalObservable(() => new ResellerAccountState({}));

    useEffect(() => {
        if (isOpenDialog) {
            useResellerAccountData.init();
        }
    }, [isOpenDialog])

    // *********************
    // View
    // *********************
    return (
        <DialogComponent
            fullWidth
            defaultHeaderProps={{
                title: i18n.t('general_text_add_reseller'),
                rightNode: (
                    <>
                        <ButtonComponent
                            size='small'
                            variant={'outlined'}
                            titleText={`${i18n.t('123')}`}
                            buttonStyle={{
                                marginRight: 10
                            }}
                            action={'SAVE'}
                            handleClick={async () => {
                                /**
                                 * 1. 新建经销商
                                 * 2. 关闭弹窗
                                 * 3. 获取经销商列表数据
                                 */
                                // 开启加载
                                useResellerData.load();
                                //  新建一个经销商数据  关闭弹窗  错误标识errorFlag
                                const successFlag = await useResellerAccountData.onSave('ADD');
                                // 关闭加载
                                useResellerData.loaded();
                                // 请求成功关闭弹窗
                                if (successFlag) {
                                    // 清空表单随后刷新数据
                                    useResellerAccountData.initResellerData();
                                    // 关闭弹窗
                                    useResellerData.closeAddResellerDialog();
                                    // 成功后刷新数据
                                    await useResellerData.getResellerListData();
                                }
                            }}
                        />
                        <ButtonComponent
                            size='small'
                            variant={'outlined'}
                            titleText={`${i18n.t('general_text_save_and_update')}`}
                            handleClick={async () => {
                                /**
                                 * 1. 新增后刷新表单数据 批量新增
                                 * 2. 不关闭弹窗
                                 */
                                // 开启加载
                                useResellerData.load();
                                // 保存经销商表单数据并新建一个集团数据 不关闭弹窗 $ 批量新增
                                const successFlag = await useResellerAccountData.onSave('ADD');
                                // 关闭加载
                                useResellerData.loaded();
                                if (successFlag) {
                                    // 清空表单随后刷新数据
                                    useResellerAccountData.initResellerData();
                                    // 成功后刷新数据
                                    await useResellerData.getResellerListData();
                                }
                            }}
                        >
                            <LibraryAddIcon />
                        </ButtonComponent>
                    </>
                )
            }}
            maxWidth={'xl'}
            open={isOpenDialog}
            onClose={() => {
                // 关闭弹窗
                useResellerData.closeAddResellerDialog();
                // 清空表单
                useResellerAccountData.initResellerData();
            }}
            transitionDuration={{
                appear: 450,
                enter: 400,
                exit: 300
            }}
            footer={<></>}
        >
            {/* 新增弹窗内容 TODO 待补充 */}
            <Box className='createReseller-modal '>
                {
                    isLoading &&
                    <CustomerLoading />
                }
                {/*经销商账号视图 */}
                <ResellerAccount
                    componentSource='ADD'
                    useResellerAccountMobx={useResellerAccountData}
                />
            </Box>
        </DialogComponent>
    )
})

export default CreateResellerDialog;

